var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
let win;
let doc;
if (typeof window === 'undefined') {
    // @ts-ignore
    win = global.window;
    // @ts-ignore
    doc = global.document;
}
else {
    win = window;
    doc = document;
}
const location = (_a = win) === null || _a === void 0 ? void 0 : _a.location;
const localStorage = (_b = win) === null || _b === void 0 ? void 0 : _b.localStorage;
const navigator = (_c = win) === null || _c === void 0 ? void 0 : _c.navigator;
const MediaMetadata = (_d = win) === null || _d === void 0 ? void 0 : _d.MediaMetadata;
const fetchNative = ((_e = win) === null || _e === void 0 ? void 0 : _e.fetch) && ((_f = win) === null || _f === void 0 ? void 0 : _f.fetch.bind(win));
const history = (_g = win) === null || _g === void 0 ? void 0 : _g.history;
const amznMusic = (_h = win) === null || _h === void 0 ? void 0 : _h.amznMusic;
const __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ = ((_j = win) === null || _j === void 0 ? void 0 : _j.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) && ((_k = win) === null || _k === void 0 ? void 0 : _k.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__.bind(win));
const performance = (_l = win) === null || _l === void 0 ? void 0 : _l.performance;
const setLocation = (uri) => {
    var _a;
    // @ts-ignore
    (_a = win) === null || _a === void 0 ? void 0 : _a.location = uri;
};
export const globals = {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__,
    amznMusic,
    document: doc,
    fetch: fetchNative,
    history,
    localStorage,
    location,
    MediaMetadata,
    navigator,
    performance,
    setLocation,
    window: win,
};
